import request from '@/utils/request'


export function getCouponActivitys(data) {
  return request({
    url: '/marketing/coupon/couponActivitys',
    method: 'get',
    params: data
  })
}

export function addCouponActivity(data) {
  return request({
    url: '/marketing/coupon/couponActivitys',
    method: 'post',
     data
  })
}

export function submitCouponActivity(id) {
  return request({
    url: '/marketing/coupon/couponActivitys/submit/' + id,
    method: 'post',
  })
}

export function getCouponActivityDetail(id) {
  return request({
    url: '/marketing/coupon/couponActivitys/' + id,
    method: 'get',
  })
}